import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox } from "vue"
import _imports_0 from '@/assets/common/img/onestop-guide-title-img1.png'


const _hoisted_1 = {
  key: 0,
  id: "com_form_contet1"
}
const _hoisted_2 = { class: "errorform" }
const _hoisted_3 = {
  key: 0,
  class: "error-message"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "com_page_title1"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "com_inner1 clearfix" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "block1" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "",
      class: "image1"
    })
  ])
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "com_inner1 clearfix"
}
const _hoisted_9 = { class: "error-message" }
const _hoisted_10 = {
  key: 2,
  id: "contents3"
}
const _hoisted_11 = { class: "com_sec1" }
const _hoisted_12 = { class: "com_inner1 clearfix" }
const _hoisted_13 = { class: "com_contents3" }
const _hoisted_14 = { class: "main_column2" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "com_d_content2" }
const _hoisted_17 = { class: "com_i_title1" }
const _hoisted_18 = ["src"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text__item" }, "すべて表示"),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text__item",
    "aria-hidden": "true"
  }, "すべて表示")
], -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "com_topic_list2" }
const _hoisted_23 = { class: "body1" }
const _hoisted_24 = {
  key: 0,
  class: "buttons1"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, "ダウンロード", -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "com_search_result_hd1" }
const _hoisted_30 = { class: "text1" }
const _hoisted_31 = { class: "com_sort_list1" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("dt", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "com_icon_sort1" }),
  /*#__PURE__*/_createTextVNode("並び替え：")
], -1)
const _hoisted_33 = { class: "selected1" }
const _hoisted_34 = { class: "list1" }
const _hoisted_35 = { class: "com_topic_list2" }
const _hoisted_36 = { class: "meta1" }
const _hoisted_37 = { class: "date1 roboto" }
const _hoisted_38 = { class: "com_tag2" }
const _hoisted_39 = { class: "body1" }
const _hoisted_40 = {
  key: 0,
  class: "com_icon_new"
}
const _hoisted_41 = {
  key: 0,
  class: "buttons1"
}
const _hoisted_42 = ["onClick"]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", null, "ダウンロード", -1)
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = {
  key: 1,
  class: "edit1"
}
const _hoisted_46 = ["onClick"]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = { class: "side_search_option1" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("h2", { class: "title1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "com_icon_option1" }),
  /*#__PURE__*/_createTextVNode("絞り込み検索 ")
], -1)
const _hoisted_53 = { class: "block_search1" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("h3", { class: "title2" }, "キーワードから探す", -1)
const _hoisted_55 = { class: "block_options_group1" }
const _hoisted_56 = { class: "com_center1 com_mgb10" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", { class: "com_icon_cross1" }, null, -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("h3", { class: "title2" }, "カテゴリーから探す", -1)
const _hoisted_59 = { class: "hd1" }
const _hoisted_60 = { class: "com_checkbox1" }
const _hoisted_61 = ["onUpdate:modelValue", "onChange"]
const _hoisted_62 = { class: "t1" }
const _hoisted_63 = { class: "body1" }
const _hoisted_64 = ["onUpdate:modelValue", "onChange"]
const _hoisted_65 = { class: "t2" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_67 = { class: "com_center1 com_mgt5" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("span", { class: "com_icon_cross1" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_component = _resolveComponent("header-component")!
  const _component_loading_overlay = _resolveComponent("loading-overlay")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_content_pagination = _resolveComponent("content-pagination")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!
  const _component_BackToTop = _resolveComponent("BackToTop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_header_component)
    ]),
    _createVNode(_component_loading_overlay, {
      active: _ctx.isLoading,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event)),
      "is-full-page": true
    }, null, 8, ["active"]),
    (_ctx.isInitError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.apiErrorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.apiErrorMessage), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.isDataFetched)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
            : _createCommentVNode("", true),
          (_ctx.errorMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.errorMessage), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isDataFetched)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("section", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        (!_ctx.isSerched)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              _createElementVNode("div", _hoisted_16, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCategoryListData, (item) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: item.categoryId,
                                    class: _normalizeClass({ disabled: _ctx.isProcessing })
                                  }, [
                                    _createElementVNode("div", _hoisted_17, [
                                      _createElementVNode("div", null, [
                                        _createElementVNode("img", {
                                          src: _ctx.getImageUrl(item.imgFileName),
                                          alt: "",
                                          class: "icon-c-doc1"
                                        }, null, 8, _hoisted_18),
                                        _createElementVNode("h2", null, _toDisplayString(item.categoryName), 1)
                                      ]),
                                      _createElementVNode("div", null, [
                                        _createElementVNode("a", {
                                          href: "#",
                                          class: "com_sr_button1",
                                          onClick: _withModifiers(($event: any) => (
                            _ctx.getNarrowCategoryData(
                              item.categoryId,
                              item.categoryName
                            )
                          ), ["prevent"])
                                        }, _hoisted_21, 8, _hoisted_19)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_22, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getContentsByCategory(
                          item.categoryId,
                          item.dispCount
                        ), (contents) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: contents.contentId
                                        }, [
                                          _createElementVNode("div", _hoisted_23, [
                                            _createVNode(_component_router_link, {
                                              to: `/${contents.detailPath}/categoryId/${contents.categoryId}/contentsId/${contents.contentId}`,
                                              class: "com_link1"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(contents.contentsTitle), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["to"])
                                          ]),
                                          (contents.fileFlg)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                                _createElementVNode("a", {
                                                  href: "#",
                                                  class: "com_dl_button2",
                                                  onClick: _withModifiers(($event: any) => (
                              _ctx.downloadFiles(
                                contents.categoryId,
                                contents.contentId,
                                ''
                              )
                            ), ["prevent"])
                                                }, _hoisted_27, 8, _hoisted_25)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128))
                                    ])
                                  ], 2))
                                }), 128))
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                              _createElementVNode("div", _hoisted_29, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("p", _hoisted_30, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.dispKeyWord), 1),
                                    _createTextVNode(_toDisplayString(_ctx.dispTitle), 1)
                                  ])
                                ]),
                                _createElementVNode("div", null, [
                                  _createElementVNode("dl", _hoisted_31, [
                                    _hoisted_32,
                                    _createElementVNode("dd", null, [
                                      _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.currentSortOptionLabel), 1),
                                      _createElementVNode("ul", _hoisted_34, [
                                        _createElementVNode("li", null, [
                                          _createElementVNode("a", {
                                            href: "#",
                                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.updateSortOption('new')), ["prevent"]))
                                          }, "新着順")
                                        ]),
                                        _createElementVNode("li", null, [
                                          _createElementVNode("a", {
                                            href: "#",
                                            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.updateSortOption('category')), ["prevent"]))
                                          }, "カテゴリ順")
                                        ]),
                                        _createElementVNode("li", null, [
                                          _createElementVNode("a", {
                                            href: "#",
                                            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.updateSortOption('recommend')), ["prevent"]))
                                          }, "おすすめ順")
                                        ])
                                      ])
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_35, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedData, (item) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: item.contentId,
                                    class: _normalizeClass({ disabled: _ctx.isProcessing })
                                  }, [
                                    _createElementVNode("div", _hoisted_36, [
                                      _createElementVNode("span", _hoisted_37, _toDisplayString(item.postPeriod), 1),
                                      _createElementVNode("span", _hoisted_38, _toDisplayString(item.subCategoryName), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_39, [
                                      _createVNode(_component_router_link, {
                                        to: `/${item.detailPath}/categoryId/${item.categoryId}/contentsId/${item.contentId}`,
                                        class: "com_link1",
                                        onClick: _ctx.handleContentsLinkClick
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.contentsTitle), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to", "onClick"]),
                                      (item.newFlg)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_40, "NEW"))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (item.fileFlg)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                          _createElementVNode("a", {
                                            href: "#",
                                            class: "com_dl_button2",
                                            onClick: _withModifiers(($event: any) => (
                          _ctx.downloadFiles(item.categoryId, item.contentId, '')
                        ), ["prevent"])
                                          }, _hoisted_44, 8, _hoisted_42)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.isKaunetAdmin)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                          _createElementVNode("a", {
                                            href: "#",
                                            onClick: _withModifiers(($event: any) => (
                          _ctx.editContents(item.categoryId, item.contentId)
                        ), ["prevent"]),
                                            class: "com_edit1"
                                          }, _hoisted_48, 8, _hoisted_46)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ], 2))
                                }), 128))
                              ]),
                              _createVNode(_component_content_pagination, {
                                "current-page": _ctx.currentPage,
                                "total-pages": _ctx.totalPages,
                                "items-per-page": _ctx.itemsPerPage,
                                onPageChanged: _ctx.handlePageChange
                              }, null, 8, ["current-page", "total-pages", "items-per-page", "onPageChanged"])
                            ]))
                      ]),
                      _createElementVNode("div", _hoisted_49, [
                        (_ctx.isSerched)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "button1",
                                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.backInitDisp && _ctx.backInitDisp(...args)))
                              }, " 初期表示に戻す "),
                              _hoisted_51
                            ]))
                          : _createCommentVNode("", true),
                        _hoisted_52,
                        _createElementVNode("div", _hoisted_53, [
                          _hoisted_54,
                          _createElementVNode("div", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              name: "",
                              placeholder: "キーワードを入力",
                              onKeyup: _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_ctx.narrowSearch && _ctx.narrowSearch(...args)), ["enter"])),
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.narrowKeyword) = $event)),
                              maxlength: "50"
                            }, null, 544), [
                              [_vModelText, _ctx.narrowKeyword]
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              name: "",
                              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.narrowSearch && _ctx.narrowSearch(...args)))
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_55, [
                          _createElementVNode("div", _hoisted_56, [
                            _createElementVNode("a", {
                              href: "javascript:void(0)",
                              class: "option_uncheck_all1 com_link1",
                              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.uncheckAll && _ctx.uncheckAll(...args)))
                            }, [
                              _hoisted_57,
                              _createTextVNode("チェックを外す ")
                            ])
                          ]),
                          _hoisted_58,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedTags, (group, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "option_group1"
                            }, [
                              _createElementVNode("div", _hoisted_59, [
                                _createElementVNode("label", _hoisted_60, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    "onUpdate:modelValue": ($event: any) => ((group.isCategoryChecked) = $event),
                                    onChange: ($event: any) => (_ctx.toggleCategory(group))
                                  }, null, 40, _hoisted_61), [
                                    [_vModelCheckbox, group.isCategoryChecked]
                                  ]),
                                  _createElementVNode("span", _hoisted_62, _toDisplayString(group.categoryName), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_63, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.tags, (tag, idx) => {
                                  return (_openBlock(), _createElementBlock("label", {
                                    key: idx,
                                    class: "com_checkbox1"
                                  }, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "checkbox",
                                      "onUpdate:modelValue": ($event: any) => ((tag.isChecked) = $event),
                                      onChange: ($event: any) => (_ctx.checkCategoryStatus(group, tag))
                                    }, null, 40, _hoisted_64), [
                                      [_vModelCheckbox, tag.isChecked]
                                    ]),
                                    _createElementVNode("span", _hoisted_65, _toDisplayString(tag.tagName), 1)
                                  ]))
                                }), 128))
                              ])
                            ]))
                          }), 128)),
                          _hoisted_66,
                          _createElementVNode("button", {
                            type: "button",
                            class: "button1",
                            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.narrowSearch && _ctx.narrowSearch(...args)))
                          }, " 検索 "),
                          _createElementVNode("div", _hoisted_67, [
                            _createElementVNode("a", {
                              href: "javascript:void(0)",
                              class: "option_uncheck_all1 com_link1",
                              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.uncheckAll && _ctx.uncheckAll(...args)))
                            }, [
                              _hoisted_68,
                              _createTextVNode("チェックを外す ")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])),
    _createElementVNode("div", null, [
      _createVNode(_component_FooterComponent)
    ]),
    _createVNode(_component_BackToTop)
  ], 64))
}